module.exports = __webpack_public_path__ + "static/img/app-operation.03a8c10.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home/app-operation.png
// module id = MhRi
// module chunks = 1